import { render } from "./CommonTag.vue?vue&type=template&id=381487cb&scoped=true"
import script from "./CommonTag.vue?vue&type=script&lang=js"
export * from "./CommonTag.vue?vue&type=script&lang=js"

import "./CommonTag.vue?vue&type=style&index=0&id=381487cb&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381487cb"]])

export default __exports__